// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "جهاز الدفع",
    description: "حصّل بجهاز الدفع في الاستقبال من صفحة الحجز",
    count: "{count} جهاز | {count} أجهزة",
  },
  settings: {
    title: "أجهزة الدفع في الاستقبال",
    lead: "حصّل بجهاز الدفع من صفحة الحجز: يظهر المبلغ على الجهاز، ويدفع الضيف بالبطاقة، ويُسجَّل الحجز مدفوعاً تلقائياً.",
    listTitle: "أجهزتك",
    add: "إضافة جهاز",
    loading: "جارٍ التحميل…",
    empty: "لا يوجد لديك أي جهاز دفع متصل بعد.",
    simulatorTag: "محاكي",
    online: "متصل",
    offlineSince: "غير متصل · آخر إشارة {when}",
    neverConnected: "لم يتصل بعد",
    bridgeVersion: "الجسر {version}",
    token: "الرمز",
    newToken: "رمز جديد",
    remove: "إزالة",
    howTitle: "طريقة الربط",
    how1: "أضف الجهاز هنا وانسخ رمزه (يظهر مرة واحدة فقط).",
    how2: "على حاسوب الاستقبال المتصل به الجهاز، شغّل جسر WACheckin بهذا الرمز.",
    how3: "عندما يظهر هنا «متصل» يمكنك التحصيل من أي حجز: إضافة دفعة ← بطاقة / جهاز.",
    bankNote: "مع Redsys يجب التعاقد مع بنكك على خدمة «TPV-PC» (وضع Implantado) وجهاز معتمد لها. لا يمكن ربط جهاز مستقل يعمل عبر WiFi أو 4G.",
    addTitle: "إضافة جهاز",
    nameLabel: "الاسم",
    namePlaceholder: "مثلاً: الاستقبال",
    typeLabel: "النوع",
    typeReal: "جهاز Redsys (TPV-PC)",
    typeRealHint: "جهاز بنكك، متصل بحاسوب الاستقبال.",
    typeSim: "محاكي",
    typeSimHint: "للتجربة بلا جهاز. لا يحرّك أي أموال.",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    create: "إضافة",
    saveError: "تعذّر الحفظ. حاول مرة أخرى.",
    loadError: "تعذّر تحميل الأجهزة.",
    tokenTitle: "رمز الجهاز",
    tokenLead: "أدخل هاتين القيمتين في الجسر على حاسوب الاستقبال.",
    apiLabel: "الخادم",
    tokenLabel: "الرمز",
    copy: "نسخ",
    copied: "تم النسخ",
    tokenOnce: "احفظه الآن: لن يظهر مرة أخرى. إذا فُقد فأنشئ رمزاً جديداً وسيتوقف القديم عن العمل.",
    done: "تم",
    newTokenConfirm: "إنشاء رمز جديد لـ «{name}»؟ سيتوقف الحالي عن العمل ويجب إدخاله من جديد في الجسر.",
    removeConfirm: "إزالة الجهاز «{name}»؟ لن يمكن إرسال عمليات تحصيل إليه بعد ذلك.",
    removed: "تمت إزالة الجهاز.",
  },
  add: {
    sendTitle: "التحصيل على الجهاز",
    sendHint: "يظهر المبلغ على الجهاز ويُسجَّل الحجز مدفوعاً تلقائياً عند استخدام البطاقة.",
    online: "متصل",
    offline: "غير متصل",
    noneOnline: "لا يوجد أي جهاز متصل الآن. تأكد من تشغيل حاسوب الاستقبال وفتح الجسر.",
    manualTitle: "تم التحصيل، سجّله فقط",
    manualHint: "يُسجَّل كمدفوع دون المرور بالجهاز.",
    submit: "التحصيل على الجهاز",
  },
  line: {
    pendiente: "جارٍ الإرسال إلى الجهاز",
    enviado: "على الجهاز",
    sin_respuesta: "لا رد · تحقق",
  },
  cobro: {
    terminal: "الجهاز",
    cancel: "إلغاء التحصيل",
    hide: "المتابعة في الخلفية",
    notCharged: "لم يُحصّل",
    wasCharged: "نعم، تم التحصيل",
    retry: "إعادة المحاولة",
    close: "إغلاق",
    authCode: "رمز التفويض {code}",
    genericError: "تعذّر الإكمال. حاول مرة أخرى.",
    title: {
      pendiente: "جارٍ الإرسال إلى الجهاز…",
      enviado: "اطلب البطاقة",
      cobrado: "تم التحصيل",
      rechazado: "رُفضت البطاقة",
      cancelado: "أُلغي التحصيل",
      error: "أعطى الجهاز خطأ",
      caducado: "لم يستجب الجهاز",
      sin_respuesta: "هل تم التحصيل؟",
    },
    text: {
      pendiente: "سيظهر المبلغ على الجهاز خلال ثوانٍ.",
      enviado: "المبلغ على الجهاز الآن. بمجرد الدفع يُسجَّل الحجز تلقائياً.",
      cobrado: "هذه الدفعة مسجلة في الحجز.",
      rechazado: "لم يُحصّل أي مبلغ.",
      cancelado: "لم يُحصّل أي مبلغ.",
      error: "لم يُحصّل أي مبلغ.",
      caducado: "لم يُحصّل أي مبلغ.",
      sin_respuesta: "لم يُرجع الجهاز النتيجة. تحقق من الجهاز أو الإيصال قبل التحصيل مرة أخرى.",
    },
  },
  qr: {
    button: "عرض رمز QR",
    title: "امسح للدفع",
    text: "يمسحه الضيف بهاتفه ويدفع في الصفحة الآمنة لبوابة الدفع. يُسجَّل الحجز مدفوعاً تلقائياً.",
    copy: "نسخ الرابط",
    copied: "تم نسخ الرابط",
    close: "إغلاق",
  },
};
